module.exports = __webpack_public_path__ + "static/media/img-browser.6afdd384.png";